export const mainBlue = '#009bf2'
export const mainLightGrey = '#4B4B4B'
export const white = '#ffffff'
